//
// products-constants.js
//
// Copyright (c) 2015 by Curalate, Inc.
//
/* global angular:false */
((() => {
    const constants = angular.module('products.constants', []);

    constants.constant('PRODUCTS_CONSTANTS', {
        'FEED_TYPES': [
            'universal',
            'google',
            'hpff',
            'intelligentreach',
        ],
        'CONTENT_TYPES': [
            'text/csv',
            'text/csv-unescaped',
            'text/psv',
            'text/ssv',
            'text/tab-separated-values',
            'text/tab-separated-values-escaped',
            'text/xml',
            'application/rss+xml',
            'application/atom+xml',
        ],
        'COMPRESSION_TYPES': [
            'none',
            'zip',
            'gzip',
        ],
        'SAMPLE_COLUMN_NAMES': [
            'id',
            'externalId',
            'title',
            'description',
            'feedId',
            'groupingId',
            'url',
            'imageUrl',
            'brand',
            'color',
            'size',
            'material',
            'manufacturer',
            'category',
            'productType',
            'gender',
            'age',
            'price',
            'created',
            'lastUpdated',
            'customInfo',
        ],
    }
    );
}))();
